import { X } from 'lucide-react';
import { useProfile } from '../../../../../context/profile/ProfileContext';

const BillingCycleModal = () => {
  const {
    subscription,
    showCycModal,
    setShowCycModal,
    isSwitchingAnnual,
    handleSwitchToAnnual,
    formatCurrency
  } = useProfile();

  if (!showCycModal) return null;

  const currentPlan = subscription?.plan_id;
  const planName = currentPlan?.name || 'Pro';
  const monthlyPrice = currentPlan?.monthly_price || (currentPlan?.slug === 'growth' ? 3499 : currentPlan?.slug === 'starter' ? 699 : 1499);
  const gstPercentage = currentPlan?.gst_percentage ?? 18;
  const annualPrice = currentPlan?.yearly_price || Math.round(monthlyPrice * 12 * 0.80);
  const annualMonthlyEquivalent = currentPlan?.annual_monthly_equivalent || Math.round(annualPrice / 12);
  const annualGstAmount = Math.round(annualPrice * (gstPercentage / 100));
  const annualTotalWithGst = annualPrice + annualGstAmount;
  const annualSavings = (monthlyPrice * 12) - annualPrice;

  return (
    <div
      className="fixed inset-0 z-[99999] bg-black/50 backdrop-blur-xs flex items-center justify-center p-4 overflow-y-auto"
      onWheel={(e) => e.stopPropagation()}
      onTouchMove={(e) => e.stopPropagation()}
    >
      <div className="bg-white rounded-2xl max-w-md w-full overflow-hidden shadow-2xl animate-modal-entry">
        <div className="p-6 pb-4 flex justify-between items-start">
          <div>
            <h2 className="font-bold text-lg text-slate-900">Switch to Annual Billing</h2>
            <span className="inline-block mt-0.5 text-[11px] font-bold text-[#067978] bg-teal-50 px-2 py-0.5 rounded-md border border-teal-100">
              Save 20% on {planName} Plan ({formatCurrency(annualMonthlyEquivalent)}/mo)
            </span>
          </div>
          <button onClick={() => setShowCycModal(false)} className="p-1 hover:bg-slate-100 rounded-lg text-slate-400 cursor-pointer">
            <X size={18} />
          </button>
        </div>
        <div className="p-6 pt-0 space-y-4">
          <p className="text-xs text-slate-600 leading-relaxed">
            Switch your <b>{planName}</b> plan to annual billing at just <b>{formatCurrency(annualMonthlyEquivalent)}/month</b> (billed annually at {formatCurrency(annualPrice)} + {gstPercentage}% GST, {formatCurrency(annualTotalWithGst)}/yr). You save <b>{formatCurrency(annualSavings)}</b> every year.
          </p>
          <div className="bg-slate-50 rounded-xl p-3.5 border border-slate-100 space-y-1.5 text-xs text-slate-600">
            <div className="flex justify-between">
              <span>Annual Plan ({planName}) · {formatCurrency(annualMonthlyEquivalent)}/mo</span>
              <span className="font-semibold text-slate-800">{formatCurrency(annualPrice)}</span>
            </div>
            <div className="flex justify-between text-slate-500">
              <span>GST ({gstPercentage}%)</span>
              <span>{formatCurrency(annualGstAmount)}</span>
            </div>
            <div className="border-t border-slate-200 pt-1.5 flex justify-between font-bold text-slate-900">
              <span>Total Due Today</span>
              <span className="text-[#067978]">{formatCurrency(annualTotalWithGst)}</span>
            </div>
          </div>
          <div className="flex gap-3 justify-end pt-2">
            <button
              type="button"
              onClick={() => setShowCycModal(false)}
              disabled={isSwitchingAnnual}
              className="px-4 py-2 border border-slate-200 hover:bg-slate-50 text-xs font-bold text-slate-600 rounded-xl cursor-pointer"
            >
              Not now
            </button>
            <button
              type="button"
              onClick={handleSwitchToAnnual}
              disabled={isSwitchingAnnual}
              className="px-4 py-2 bg-[#067978] hover:bg-[#05605f] text-white text-xs font-bold rounded-xl flex items-center gap-1.5 cursor-pointer shadow-md shadow-[#067978]/20 disabled:opacity-60"
            >
              {isSwitchingAnnual ? (
                <span className="w-3.5 h-3.5 border-2 border-current border-t-transparent rounded-full animate-spin" />
              ) : (
                <span>Pay {formatCurrency(annualTotalWithGst)} &amp; Switch</span>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingCycleModal;
